import { zodResolver } from "@hookform/resolvers/zod"
import { useRemixForm } from "remix-hook-form"
import { z } from "zod"
import { useIsPending } from "#app/utils/misc"
import Loader from "../loader"
import { Button } from "../ui/button"
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "../ui/forms/hook-form/form"
import { Input } from "../ui/forms/hook-form/input"
import { Textarea } from "../ui/textarea"
import { TypographyH1 } from "../ui/typography"

// 1. Schema
export const ContactFormSchema = z.object({
	name: z.string({
		required_error: "Se requiere un nombre",
	}),
	email: z
		.string({
			required_error: "Se requiere un correo electrónico",
		})
		.email("Correo electrónico no válido."),
	subject: z.string({
		required_error: "Se requiere un asunto.",
	}),
	message: z.string({
		required_error: "Se requiere un mensaje.",
	}),
})

// 2. Resolver
export const contactFormResolver = zodResolver(ContactFormSchema)

// 3. Action

// 4. Form
export default function ContactForm() {
	const isPending = useIsPending()
	const form = useRemixForm<z.infer<typeof ContactFormSchema>>({
		mode: "onSubmit",
		resolver: contactFormResolver,
	})

	return (
		<Form {...form}>
			<form
				onSubmit={form.handleSubmit}
				className="relative flex flex-1 flex-col gap-4"
			>
				{isPending && <Loader />}
				<div className="mb-6">
					<TypographyH1>Contacto</TypographyH1>
				</div>

				<div className="flex w-full flex-col gap-y-2">
					<FormField
						control={form.control}
						name="name"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Nombre</FormLabel>
								<FormControl>
									<Input placeholder="Panic" {...field} />
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>
					<FormField
						control={form.control}
						name="email"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Correo electrónico</FormLabel>
								<FormControl>
									<Input placeholder="panic@thedis.co" {...field} />
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>
					<FormField
						control={form.control}
						name="subject"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Asunto</FormLabel>
								<FormControl>
									<Input placeholder="Asunto" {...field} />
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>
					<FormField
						control={form.control}
						name="message"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Mensaje</FormLabel>
								<FormControl>
									<Textarea rows={6} placeholder="Mensaje" {...field} />
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>
				</div>

				<div className="flex items-center justify-between">
					<Button disabled={form.formState.isSubmitting} className="mt-4 w-fit">
						Enviar
					</Button>
				</div>
			</form>
		</Form>
	)
}
